(function (angular) {
    'use strict';

    angular.module('app')
        .controller('adminForumController', adminForumController);

    adminForumController.$inject = [
        '$http',
        '$q',
        '$window',
        'ForumCategoriesApi',
        'ForumRepliesApi',
        'ForumThreadsApi',
        'ForumCategory',
        'handleError'
    ];

    function adminForumController(
        $http,
        $q,
        $window,
        ForumCategoriesApi,
        ForumRepliesApi,
        ForumThreadsApi,
        ForumCategory,
        handleError
    ) {
        var vm = this;

        // properties
        vm.isLoading = false;
        vm.page = 1;
        vm.sort = 'created_at';
        vm.order = 'desc';
        vm.filters = {
            page: 1,
            page_size: 15,
            hide_category_groups: false,

        };
        vm.categories = {};
        vm.threads = {};
        vm.replies = 0;

        // methods
        vm.getCategories = getCategories;
        vm.getThreads = getThreads;
        vm.editCategory = editCategory;
        vm.createCategory = createCategory;
        vm.setIsForumActive = setIsForumActive;

        function getAll() {
            getCategories().then(function () {
                return getThreads();
            }).then(function () {
                vm.threads.data.map(function (thread) {
                    vm.replies += thread.total_replies;
                });
            });
        }

        /**
         * Retrieves adverts from the api and adds to scope
         * @return {void}
         */
        function getCategories() {
            return $q(function (resolve) {
                vm.isLoading = true;
                ForumCategoriesApi.query(vm.filters, function (response) {
                    vm.categories = response;
                    vm.isLoading = false;
                    resolve();
                }, function (err) {
                    handleError(err);
                    vm.isLoading = false;
                    resolve();
                });
            });
        }

        /**
         * Retrieves adverts from the api and adds to scope
         * @return {void}
         */
        function getThreads() {
            return $q(function (resolve) {
                vm.isLoading = true;
                ForumThreadsApi.query(vm.filters, function (response) {
                    vm.threads = response;
                    vm.isLoading = false;
                    resolve();
                }, function (err) {
                    handleError(err);
                    vm.isLoading = false;
                    resolve();
                });
            });
        }

        /**
         * Edits the category via a modal, and updates model in this controller
         * @param  {int} categoryId - ID of category to edit
         * @return {void}
         */
        function editCategory(categoryId) {
            ForumCategory.edit(categoryId)
                .result.then(function () {
                    getCategories();
                }, function (err) {
                    handleError(err);
                });
        }

        /**
         * Creates an advert then refreshes adverts
         * @return {void}
         */
        function createCategory() {
            ForumCategory.create()
                .result.then(function () {
                    getCategories();
                });
        }

        /**
         * Activate/deactivate forum.
         * @param {Boolean} isActive
         */
        function setIsForumActive(isActive) {
            $http.put('/api/settings/forum', {is_forum_active: isActive})
                 .then(function () {
                     $window.location.reload();
                 }, handleError);
        }

        getAll();

    }

}(angular));
